import * as React from "react";
import { useMemo } from "react";
import useLocation from "routing/useLocation";
import useQuery from "./useQuery";
const withLocation = (Component) => (props) => {
  const location = useLocation();
  const query = useQuery();
  const locationWithQuery = useMemo(() => ({ ...location, query }), [location, query]);
  return /* @__PURE__ */ React.createElement(Component, { ...props, location: locationWithQuery });
};
export default withLocation;
